'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _raf = require('raf');

var _raf2 = _interopRequireDefault(_raf);

var _logger = require('./logger');

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Raf class.
 *
 * @class
 *
 * @license https://opensource.org/licenses/MIT
 *
 * @author Patrick Heng & Fabien Motte <hengpatrick.pro@gmail.com/contact@fabienmotte.com>
 *
 * @example
 * const callback = () => { }
 * Raf.add(callback)
 */
var Raf = function () {
  /**
   * Creates an instance of Raf.
   *
   * @constructor
   */
  function Raf() {
    _classCallCheck(this, Raf);

    /**
     * Listeners.
     * @type Array
     * @private
     */
    this._listeners = [];

    /**
     * Binded instance.
     * @type Boolean
     * @private
     */
    this._binded = false;

    /**
     * Raf ID.
     * @type Number|null
     * @private
     */
    this._raf = null;
  }

  /**
   * Bind update method.
   */


  _createClass(Raf, [{
    key: 'bind',
    value: function bind() {
      if (this._binded === true) {
        return _logger2.default.warn('Raf instance is already binded');
      }

      this._binded = true;
      this._update = this._update.bind(this);

      this._baseTime = Date.now();

      this._raf = (0, _raf2.default)(this._update);
    }

    /**
     * Unbind update method and remove all listeners.
     */

  }, {
    key: 'unbind',
    value: function unbind() {
      this._binded = false;

      if (this._raf !== null) {
        _raf2.default.cancel(this._raf);
        this._raf = null;
      }

      this._listeners = [];
    }

    /**
     * Add a listener.
     *
     * @param {listenerCallback} callback Listener callback.
     * @param {Number} [fps=60] FPS targeted.
     * @param {Number} [delay=0] Delay in milliseconds before start.
     * @param {Boolean} [once=false] Call once.
     *
     * @returns {Object} Listener data.
     */

  }, {
    key: 'add',
    value: function add(callback) {
      var fps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60;
      var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var once = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      if (typeof callback !== 'function') {
        return _logger2.default.error('add() : Callback argument must be a function');
      }

      var date = new Date();

      var data = {
        id: this._listeners.length,
        callback: callback,
        fps: fps,
        delay: delay,
        once: once,
        deltaTargeted: 1000 / fps,
        lastTime: date.getTime()
      };

      this._listeners.push(data);

      if (!this._binded) {
        this.bind();
      }

      return data;
    }

    /**
     * Add once listener.
     *
     * @param {listenerCallback} callback Listener callback.
     * @param {Number} [fps=60] FPS targeted.
     * @param {Number} [delay=0] Delay in milliseconds before start.
     *
     * @returns {Object} Listener data.
     */

  }, {
    key: 'addOnce',
    value: function addOnce(callback) {
      var fps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60;
      var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      return this.add(callback, fps, delay, true);
    }

    /**
     * Remove a listener.
     *
     * @param {listenerCallback} callback Listener callback.
     */

  }, {
    key: 'remove',
    value: function remove(callback) {
      if (typeof callback !== 'function') {
        return _logger2.default.error('remove() : Callback argument must be a function');
      }

      for (var i = 0, l = this._listeners.length; i < l; i++) {
        if (this._listeners[i].callback === callback) {
          this._listeners.splice(i, 1);
          break;
        }
      }
    }

    /**
     * Update.
     * @private
     */

  }, {
    key: '_update',
    value: function _update() {
      var now = Date.now();
      var elapsedTime = now - this._baseTime;

      for (var i = 0; i < this._listeners.length; i++) {
        var data = this._listeners[i];
        var delta = now - data.lastTime;

        if (delta < data.deltaTargeted && data.fps < 60) {
          continue;
        }

        data.lastTime = now;

        if (data.delay > 0) {
          if (elapsedTime < data.delay) {
            continue;
          }
        }

        data.callback(delta, elapsedTime, now);

        if (data.once) {
          this.remove(data.callback);
        }
      }

      if (this._binded) {
        (0, _raf2.default)(this._update);
      }
    }
  }]);

  return Raf;
}();

/**
 * Listener callback.
 *
 * @callback listenerCallback
 *
 * @param {Number} delta Delta between two frames in milliseconds.
 * @param {Number} elapsedTime Elapsed time in milliseconds since the Raf was binded.
 * @param {Number} now Current timestamp in milliseconds.
 */

exports.default = new Raf();
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-raf/lib/index.js
// module id = 122
// module chunks = 1